<div class="p-fluid">

    <div class="p-grid" *ngIf="entidade.id">
      <div class="p-col-12 p-lg-2">
        <label for="id">Id:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="id" disabled [ngModel]="entidade.id" />
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="origem">Origem:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="origem" disabled [ngModel]="entidade.fonteDados?.nome" />
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="origemId">Id Origem:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="origemId" disabled [ngModel]="entidade.origemId" />
      </div>
    </div>
  <div class="p-grid">
    <div class="p-col-12 p-lg-2">
      <label for="situacao">Situação:</label>
    </div>
    <div class="p-col-12 p-lg-10">
      <input pInputText type="text" name="situacao" disabled [ngModel]="entidade.situacao" />
    </div>
  </div>
    <div class="p-grid">
        <div class="p-col-12 p-lg-2">
            <label for="nome">Nome:</label>
        </div>
        <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="nome" disabled [ngModel]="entidade.nome" />
        </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="nome">Orgão Justiça:</label>
      </div>
      <div class="p-col-12 p-lg-7">
        <p-dropdown
          placeholder="Selecione..."
          [options]="orgaoJusticaItens"
          [showClear]="true"
          optionLabel="nome"
          dataKey="id"
          filter="true"
          [(ngModel)]="orgaoJustica"
          [disabled]="isOrgaoJusticaBloqueado"
          autoZIndex = "false"
          [baseZIndex]="0">
        </p-dropdown>
      </div>
      <div class="p-col-12 p-lg-3">
        <button pButton (click)="sincronizar(orgaoJustica.id)" class="p-primary" label="Sincronizar"
                icon="pi pi-refresh" title="Sincroniza os órgãos julgadores do órgão de justiça selecionado"
                [disabled]="orgaoJustica === undefined"
        ></button>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
          <label for="nome">Órgão Julgador:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <p-autoComplete
          [(ngModel)]="entidade.orgaoJulgador"
          [suggestions]="orgaoJulgadorSugestoes"
          (completeMethod)="onCompleteOrgaoJulgador($event.query)"
          field="nome"
          appendTo="body"
          forceSelection="true"
          required="true"
          placeholder="Pesquise por um órgão julgador (no mínimo 3 caracteres)"
          showEmptyMessage="true"
          minLength=3
          virtualScroll="true"
          emptyMessage="Não foi encontrado nenhum órgão julgador"
          delay=700
          [dropdown]="true">
          <ng-template let-orgao pTemplate="item">
            <span>{{orgao.id}}&nbsp; - &nbsp;</span>
            <span>{{orgao.nome}} &nbsp;</span>
            <span class="badge" [ngClass]="orgao.situacao == 'ATIVO' ? 'badge-success' : 'badge-danger'">
              {{orgao.situacao | dominio: 'getSituacaoItens'}}
            </span>
          </ng-template>
        </p-autoComplete>
      </div>
    </div>

    <div class="p-grid" style="margin-bottom: 12px;">
      <div class="p-col-12 p-lg-2">
        <label for="tipo">Pendente de revalidação:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <p-selectButton [options]="booleanoSimNaoItens" disabled [(ngModel)]="entidade.pendenteRevalidacao"></p-selectButton>
      </div>
    </div>
</div>
